import * as XLSX from 'xlsx'

import { generateCSVTable } from '@utils/prepare.csv.utils'
import { generatePDFTable } from '@utils/prepare.pdf.utils'

export const useGenerateDocumentFile = (exportFilename = 'report', data: string[][]) => {
  const handleGeneratePDF = () => {
    generatePDFTable({ data, fileName: exportFilename })
  }

  const handleGenerateCSV = () => {
    generateCSVTable({ data, fileName: exportFilename })
  }

  const handleGenerateExcel = () => {
    const wb = XLSX.utils.book_new()
    const ws = XLSX.utils.aoa_to_sheet(data)
    const sheetName = exportFilename.replace(/[:\\/?*[\]]/g, '_').slice(0, 31) || 'report'

    XLSX.utils.book_append_sheet(wb, ws, sheetName)
    XLSX.writeFile(wb, `${exportFilename}.xlsx`)
  }

  return {
    handleGenerateExcel,
    handleGeneratePDF,
    handleGenerateCSV,
  }
}
